import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-shared-button',
  standalone: false,
  templateUrl: './shared-button.component.html',
  styleUrl: './shared-button.component.scss',
})
export class SharedButtonComponent {
  @Input() buttonText: string = 'Click Me';
  @Input() size: 'small' | 'big' = 'small';
  @Input() textColor: string = 'text-black';
  @Input() buttonColor: string = 'bg-white';
  @Input() previousIcon?: string;
  @Input() nextIcon?: string;
  @Input() iconWhite?: boolean = false;
  @Input() fullWidth?: boolean = false;
}
